export enum CountryEnum {
    US = 1,
    CA = 2,
    UK = 3,
    FR = 4,
    RO = 5
}
